import { FC } from 'react'
import { Visible } from '@leroy-merlin-br/backyard-react'

import * as S from './styled'
import { OfferConditionsShape } from '../../icons'

const OfferConditions: FC = () => (
  <S.Container>
    <S.Wrapper>
      <S.Content>
        <S.Title>
          <span>07</span> Condições da oferta
        </S.Title>

        <S.InfoContainer>
          <p>
            As condições de utilização de cada cupom de desconto estarão
            claramente descritas na oferta, não se aplicando nestas comunicações
            o disposto nos itens 6 e 7 deste Regulamento.
          </p>

          <p>
            As condições de utilização do cashback devem observar as cláusulas
            presentes nos Termos e Condições de Uso, salvo em casos de condições
            específicas descritas no momento da oferta.
          </p>
        </S.InfoContainer>

        <Visible when={['tera']}>
          <OfferConditionsShape />
        </Visible>
      </S.Content>
    </S.Wrapper>
  </S.Container>
)

export default OfferConditions
